import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .hefesto-progress__label {
    display: none;
  }
`;

export const Subtitle = styled.span`
  font-size: 1rem;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
